// extracted by mini-css-extract-plugin
module.exports = {"listContainer":"MenuList_listContainer__BzhMf","headline":"MenuList_headline__uCSpG","menuList":"MenuList_menuList__My8P4"};